import { AxiosResponse } from "node_modules/axios";

export const reloadOnSuccess = (response: AxiosResponse<server.dto.ApiResponse>) => {
  if (response.data.hasErrors) {
    displayErrors(response);
  } else {
    window.location.reload();
  }
}



export const displayErrors = (response: AxiosResponse<server.dto.ApiResponseWrapper<any> | server.dto.ApiResponse>) => {
  if (response.data.hasErrors) {
    const errorMessages = response.data.errors.map(e => e.message);
    const errors = errorMessages.join("\n");

    window.displayGenericModal("Error", errors, "tiny", "error");
  }
}
